<template>
  <div class="gmf-item-grid" :style="gridStyle" role="grid">
    <ListItem
      v-for="item in items"
      :key="item.uuid || item.id"
      :item="item"
      role="gridcell"
      @click="selectItem(item)"
      :showColors="showColors"
      :showName="showNames"
      :textAlign="textAlign"
      :selected="selectedItemMap[item.uuid]"
      :class="{ 'gmf-large-item': showLargeBundles && item.showLarge }"
    />
  </div>
</template>
<style>
.gmf-item-grid {
  position: relative;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--gmf-p-4) var(--gmf-p-3);
  margin-bottom: var(--gmf-p-4);
  margin-top: var(--gmf-p-5);
  /* flex-wrap: wrap; */
}

@media (min-width: 786px) {
  .gmf-item-grid  {
    grid-template-columns: repeat(4, 1fr);
    gap: var(--gmf-p-4);
  }
}

.gmf-item-grid > * {
  /* Prevent grid blowout */
  min-width: 0;
  /* flex: 1; */
}

.gmf-large-item {
  grid-column: span 2;
}
</style>
<script>
import ListItem from './ListItem.vue';
import elSize from '@/utils/mixins/elSize';

export default {
  components: {
    ListItem,
  },
  props: {
    items: {
      Type: Array,
      default: [],
    },
    columns: {
      type: Number,
      default: 0,
    },
    showColors: {
      type: Boolean,
      default: false,
    },
    showNames: {
      type: Boolean,
      default: true,
    },
    textAlign: {
      type: String,
      default: 'center',
    },
    selectedItems: {
      type: Array,
      default: () => [],
    }
  },
  mixins: [elSize],
  computed: {
    showLargeBundles () {
      const w = this.elSize.width;
      return w < 568;
    },
    gridTemplateColumns () {
      return `repeat(${this.columns}, 1fr)`;
    },
    gridStyle () {
      const style = {};

      if (this.columns) {
        style.gridTemplateColumns = this.gridTemplateColumns;
        style.gap = 'var(--gmf-p-5) var(--gmf-p-4)';
      }

      return style;
    },
    selectedItemMap () {
      const map = {};
      for (const item of this.selectedItems) {
        map[item.uuid] = true;
      }

      return map;
    },
  },
  methods: {
    selectItem (item) {
      this.$emit('select', item);
    },
  }
};
</script>
